import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faPenToSquare, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { useContext, useEffect, useMemo, useState } from "react"
import services from "../../../../services/services";
import { Urls } from "../../../../services/Urls";
import _ from "underscore";
import { ToastContext } from "../../../../context/ToastContext";

export const useFieldConfigSchemes = ({ filterValues, setFilterValues }) => {

    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [formValues, setFormValues] = useState({});
    const [loader, setLoader] = useState({ grid: false, btn: false });
    const [rowData, setRowData] = useState([]);
    const columns = [
        {
            key: "field_configuration_scheme_name",
            label: "Scheme Name",
            style: { width: "45%" },
            render: (row) => <div className="py-1">
                <div className="fw-bold text-truncate" style={{ fontSize: "12px" }} title={row?.field_configuration_scheme_name}>{row?.field_configuration_scheme_name} {row?.is_default && <span className="px-2" style={{backgroundColor: "#efefef", borderRadius: "5px", border: "1px solid #e3e3e3"}}>DEFAULT</span>}</div>
                <div className="fw-semibold text-truncate" style={{ fontSize: "10px", color: "#a1a1a1" }} title={row?.field_configuration_scheme_description}>{row?.field_configuration_scheme_description}</div>
            </div>
        },
        {
            key: "projects",
            label: "Project Association",
            style: { width: "40%", alignContent: "center" },
            render: (row) => <ul className="m-0 primary-list-disc py-1">
                {row?.projects?.split(",")?.map(item => (
                    <li className="fw-semibold">{item}</li>
                ))}
            </ul>
        },
        {
            key: "is_active",
            label: "Active",
            style: { width: "5%", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            render: (row) => (row?.is_active && <div className="text-success"><FontAwesomeIcon icon="fa-solid fa-circle-check" /></div>)
        },
        {
            key: "",
            label: "Actions",
            sort: false,
            style: { width: "10%" },
            headerStyle: { textAlign: "center" },
            render: (row) => <div className="d-flex gap-3 align-items-center justify-content-center">
                <div className="c-pointer text-primary" title="Associate Types" onClick={() => setFilterValues((prev) => ({ ...prev, scheme: row, apiCall: true }))}><FontAwesomeIcon icon="fa-solid fa-gear" /></div>
                <div className="c-pointer text-primary" title="Edit" onClick={() => setFormValues((prev) => ({ ...prev, editData: row, visible: true, name: row?.field_configuration_scheme_name, description: row?.field_configuration_scheme_description, isActive: row?.is_active, isDefault: row?.is_default }))}><FontAwesomeIcon icon={faPenToSquare} /></div>
                <div className="c-pointer text-secondary" title="Create Copy" onClick={() => setFormValues((prev) => ({ ...prev, visible: true, isCopy: true, editData: row, name: `Copy of ${row?.field_configuration_scheme_name}`, description: row?.field_configuration_scheme_description }))}><FontAwesomeIcon icon={faCopy} /></div>
                <div className="c-pointer text-danger" title="Delete" onClick={() => setFormValues((prev) => ({ ...prev, isDelete: true, editData: row }))}><FontAwesomeIcon icon={faTrashCan} /></div>
            </div>
        },
    ]
    const formFields = [
        {
            label: "Field configuration scheme name",
            name: "name",
            col: "12",
            type: "text",
            required: true,
        },
        {
            label: "Description",
            name: "description",
            col: "12",
            type: "text",
        },
        {
            label: "Is Active",
            name: "isActive",
            col: "3",
            type: "checkbox",
            hide: formValues?.isCopy
        },
        {
            label: "Is Default",
            name: "isDefault",
            col: "3",
            type: "checkbox",
            hide: formValues?.isCopy || (!_.isEmpty(_.findWhere(rowData, {is_default: true})) && !formValues?.editData?.is_default)
        },
    ]

    useEffect(() => {
        (_.isEmpty(filterValues?.scheme) && filterValues?.apiCall) && getFieldConfigSchemes();
    }, [filterValues?.apiCall])

    const getFieldConfigSchemes = async () => {
        try {
            setLoader((prev) => ({ ...prev, grid: true }));
            const res = await services.getInvokeRemote("GET", Urls("GETFIELDCONFIGURATIONSCHEMESUMMARY"), {});
            if (res?.body?.error_status === false) {
                const data = res?.body?.data?.field_configuration_schemes_list?.sort((a, b) => a?.field_configuration_scheme_name?.localeCompare(b?.field_configuration_scheme_name));
                setRowData(data);
            }
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setLoader((prev) => ({ ...prev, grid: false }));
            setFilterValues(prev => ({ ...prev, apiCall: false }));
        }
    }

    const upsertFieldConfigScheme = async () => {
        try {
            if (!formValues?.name?.trim() && !formValues?.isDelete) {
                showInfo("Info", "Please enter the scheme name");
                return;
            } else {
                // check for unique scheme name
                let allScheme = _.pluck(rowData?.schemeData?.[0]?.children, "field_configuration_scheme_name")?.map(item => item?.toLowerCase()?.trim());
                if (!_.isEmpty(formValues?.editData) && !formValues?.isCopy) {
                    allScheme = _.filter(allScheme, item => item !== formValues?.editData?.field_configuration_scheme_name?.toLowerCase()?.trim());
                }
                if (allScheme?.includes(formValues?.name?.toLowerCase()?.trim())) {
                    showInfo("Info", "This scheme name already exists!");
                    return;
                } else if (!_.isEmpty(formValues?.editData) && (formValues?.editData?.field_configuration_scheme_name?.trim() === formValues?.name?.trim()) && (formValues?.editData?.field_configuration_scheme_description?.trim() === formValues?.description?.trim()) && (formValues?.editData?.is_active === formValues?.isActive) && (formValues?.editData?.is_default === formValues?.isDefault) && !formValues?.isCopy) {
                    showInfo("Info", "No changes made!");
                    return;
                } else {
                    setLoader((prev) => ({ ...prev, btn: true }));
                    let payload = {};
                    let url = "";
                    if (formValues?.isCopy) {
                        payload = {
                            source_scheme_id: formValues?.editData?.field_configuration_scheme_id || 0,
                            new_scheme_name: formValues?.name || "",
                            new_scheme_description: formValues?.description || ""
                        }
                        url = "UPSERTFIELDCONFIGURATIONCOPYSCHEME";
                    } else {
                        payload = {
                            field_configuration_scheme_id: (!_.isEmpty(formValues?.editData) ? formValues?.editData?.field_configuration_scheme_id : 0) || 0,
                            field_configuration_scheme_name: formValues?.name || "",
                            field_configuration_scheme_description: formValues?.description || "",
                            is_default: formValues?.isDefault || false,
                            is_active: formValues?.isActive || false,
                            is_deleted: formValues?.isDelete || false
                        }
                        url = "UPSERTFIELDCONFIGURATIONSCHEME";
                    }
                    const res = await services.getInvokeRemote("POST", Urls(url), payload);
                    if (res?.body?.error_status === false) {
                        showSuccess("Success", res?.body?.message);
                        if (formValues?.isDelete) {
                            setRowData((prev) => [..._.filter(prev, item => item?.field_configuration_scheme_id !== payload?.field_configuration_scheme_id)]);
                        } else {
                            getFieldConfigSchemes();
                        }
                        setFormValues({});
                    }
                }
            }
        } catch (error) {
            console.error("Error: ", error);
            error?.response?.data?.errorMessage && showError("Error", error?.response?.data?.errorMessage);
        } finally {
            setLoader((prev) => ({ ...prev, btn: false }));
        }
    }

    const handleChange = (item, e) => {
        setFormValues((prev) => ({ ...prev, [item?.name]: item?.type === "checkbox" ? e?.target?.checked : e?.target?.value }));
    }

    const filteredData = useMemo(() => {
        if (!formValues?.search?.trim()) return rowData;
        return rowData?.filter((item) => item?.field_configuration_scheme_name?.toLowerCase()?.includes(formValues?.search.toLowerCase()));
    }, [rowData, formValues?.search]);

    return { columns, rowData: filteredData, loader, formValues, setFormValues, upsertFieldConfigScheme, formFields, handleChange }
}